import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import { ordenarPorTallaYColor } from "../../../../utils/tallas";
import { abrirPDF } from "../../../../utils/abrirPDF";

function ListadoUbicaciones() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;

  const [inventarios, setInventarios] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedTalla, setSelectedTalla] = useState("");
  const [total_cantidad_anterior, setTotalCantidadAnterior] = useState(0);
  const [total_cantidad_nueva, setTotalCantidadNueva] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [comments2, setComments2] = useState([]);
  const [movimientos, setMovimientos] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColores = response.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function BuscaArticulo(event) {
    setSelectedArticulo(event.target.value);
    // Jala Inventario
    axios
      .get(`${URL_INVENTARIOS}Ubicaciones/${event.target.value}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        setComments(allDisponible);
        setInventarios(allDisponible);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  function PDFTabla() {
    let total_cantidad = 0;
    // Copia ordenada por talla ascendente dentro de cada artículo + color
    const dataOrdenada = ordenarPorTallaYColor(
      commentsData,
      (r) => r.talla,
      (r) => r.color,
      (r) => r.codigo
    );
    const data = dataOrdenada.map((a) => {
      total_cantidad = total_cantidad + a.cantidadAnterior;
      return [
        a.codigo,
        a.color,
        a.talla,
        new Intl.NumberFormat("en-US").format(a.cantidadAnterior),
        a.area,
        a.ubicacion,
      ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Ubicaciones`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Color",
          "Talla",
          "Cantidad",
          "Almacen",
          "Ubicacion",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_cantidad),
        ],
      ],
      showFoot: "lastPage",
    });
    abrirPDF(doc);
  }

  function excel() {
    const dataExcel = commentsData.map((a) => {
      return {
        Codigo: a.codigo,
        Color: a.color,
        Talla: a.talla,
        Cantidad: a.cantidadAnterior,
        Almacen: a.area,
        Ubicacion: a.ubicacion,
      };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoUbicaciones";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoUbicaciones",
        sheetFilter: [
          "Codigo",
          "Nombre",
          "Cantidad",
          "Almacen",
          "Ubicacion",
        ],
        sheetHeader: [
          "Codigo",
          "Nombre",
          "Cantidad",
          "Almacen",
          "Ubicacion",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_cantidad = 0;
    // Copia ordenada por talla ascendente dentro de cada artículo + color
    const dataOrdenada = ordenarPorTallaYColor(
      commentsData,
      (r) => r.talla,
      (r) => r.color,
      (r) => r.codigo
    );
    const data = dataOrdenada.map((a) => {
      total_cantidad = total_cantidad + a.cantidadAnterior;
      return [
        a.codigo,
        a.color,
        a.talla,
        new Intl.NumberFormat("en-US").format(a.cantidadAnterior),
        a.area,
        a.ubicacion,
      ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Ubicaciones`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Color",
          "Talla",
          "Cantidad",
          "Almacen",
          "Ubicacion",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_cantidad),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Seguimiento",
          email: mailTo,
          fileName: "ListadoUbicaciones.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Talla", field: "talla", sortable: true },
    { name: "Cantidad Anterior", field: "cantidadAnterior", sortable: false },
    { name: "Cantidad Nueva", field: "cantidad", sortable: false },
    { name: "Almacen", field: "area", sortable: false },
    { name: "Ubicacion", field: "ubicacion", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.ubicacion.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search)
      );
    }


    if (selectedColor) {
      computedComments = computedComments.filter((e) =>
        e.idColor.includes(selectedColor)
      );
    }

    if (selectedTalla) {
      computedComments = computedComments.filter((e) =>
        e.idTalla.includes(selectedTalla)
      );
    }

    setTotalItems(computedComments.length);

    let cant = computedComments.map((c) => parseFloat(c.cantidadAnterior));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadAnterior(TC);
  
    let cantN = computedComments.map((c) => parseFloat(c.cantidadNueva));
    let TCN = cantN.reduce((t, total, index) => t + total, 0);
    setTotalCantidadNueva(TCN);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" 
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedColor, selectedTalla]);

  function saveUbicacion(event) {
    event.preventDefault();
    if (comments.filter((e) => e.ubicacion == "").length > 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes Capturar la ubicacion!",
        showConfirmButton: false,
      });
    } else {
      if (total_cantidad_nueva == total_cantidad_anterior) {
        let totalUbicacion = comments.length;
        commentsData.map((a) => {
          axios
            .patch(
              `${URL_INVENTARIOS}Ubicacion`,
              {
                articulos: a.idArticulo,
                colores: a.idColor,
                tallas: a.idTalla,
                areas: a.idArea,
                cantidad: a.cantidadNueva,
                ubicacion: a.ubicacion,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalUbicacion = totalUbicacion - 1;
              if (totalUbicacion == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Cambio de Ubicacion",
                      detalle: `Modelo ${selectedArticulo}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Guardado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `La cantidad del inventario ${total_cantidad_anterior} es diferente de la cantidad registrada ${total_cantidad_nueva}`,
        });
      }
    }
  }
  const handleAddFields = () => {
    const ultimo = commentsData[commentsData.length - 1];

    setComments([
      ...comments,
      {
        _id: uuidv4(),
        activo: "Si",
        area: ultimo.area,
        idArea: ultimo.idArea,
        cantidadAnterior: 0,
        cantidadNueva: 0,
        codigo: ultimo.codigo,
        color: ultimo.color,
        idArticulo: ultimo.idArticulo,
        idColor: ultimo.idColor,
        idTalla: ultimo.idTalla,
        talla: ultimo.talla,
        ubicacion: ""
      },
    ]);
  };

  function ActualizaTotales() {
    let cant = commentsData.map((c) => parseFloat(c.cantidadNueva));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadNueva(TC);
  }

  const handleChangeInputCantidad = (id, event) => {
      const newInventarios = commentsData.map((i) => {
        if (id === i._id) {
          i[event.target.name] = parseFloat(event.target.value);
        }
        return i;
      });
      setComments(newInventarios);
      ActualizaTotales();
  };


  const handleChangeInputUbicacion = (id, event) => {
    if (
      commentsData.filter((e) => e.ubicacion == event.target.value).length > 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La ubicacion ya existe!",
        showConfirmButton: false,
      });
      const newInventarios = commentsData.map((i) => {
        if (id === i._id) {
          i.ubicacion = "";
        }
        return i;
      });
      setComments(newInventarios);
    } else {
      const newInventarios = commentsData.map((i) => {
        if (id === i._id) {
          i[event.target.name] = event.target.value;
        }
        return i;
      });
      setComments(newInventarios);
      ActualizaTotales();
    }
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-warehouse" style={{ marginRight: 8, color: "#0ea5e9" }} />
                Ubicaciones
              </h3>
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label>Articulo</Label>
            <Input
                bsSize="sm"
                type="select"
                value={selectedArticulo}
                onChange={(e) => {
                  BuscaArticulo(e);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {articulos
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.codigo} {a.descripcion}</option>;
                  })}
              </Input>
            </Col>

           
            <Col md={2}>
              <Label>Color</Label>
            <Input
                bsSize="sm"
                type="select"
                value={selectedColor}
                onChange={(e) => {
                  setSelectedColor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {colores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
             
            <Col md={2}>
              <Label>Talla</Label>
            <Input
                bsSize="sm"
                type="select"
                value={selectedTalla}
                onChange={(e) => {
                  setSelectedTalla(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {tallas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
       
          <br />
          {inventarios.length > 0 ? (
            <>
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl table-dark-header"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />

                <tbody>
                  {commentsData.map((ao) => {
                    return (
                      <tr>
                        <td>{ao.codigo}</td>
                        <td>{ao.color}</td>
                        <td>{ao.talla}</td>
                        <td>{ao.cantidadAnterior}</td>
                       
                       {selectedColor != "" && selectedTalla != "" ? (
                         <td>
                         <Input
                           bsSize="sm"
                           name="cantidadNueva"
                           type="number"
                           min="0"
                           step="any"
                           placeholder="Cantidad"
                           value={ao.cantidadNueva}
                           required
                           onChange={(event) =>
                             handleChangeInputCantidad(ao._id, event)
                           }
                         />
                       </td>
                       ) : (
                        <td>
                          <Input
                            bsSize="sm"
                            name="cantidadNueva"
                            type="number"
                            min="0"
                            step="any"
                            placeholder="Cantidad"
                            value={ao.cantidadNueva}
                            disabled
                          />
                        </td>
                       ) }

                        <td>{ao.area}</td>
                        <td>
                          {ao.cantidadAnterior > 0 ? (
                            ao.ubicacion
                          ) : (
                            <Input
                              bsSize="sm"
                              name="ubicacion"
                              type="text"
                              placeholder="Ubicacion"
                              value={ao.ubicacion}
                              onChange={(event) =>
                                handleChangeInputUbicacion(ao._id, event)
                              }
                            />
                          )}
                        </td>

                        {selectedColor != "" && selectedTalla != "" ? (
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFields}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                       ) : (
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            tabindex="-1"
                            disabled
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                       ) }
                      </tr>
                    );
                  })}
                  <tr>
                    <td></td>
                    <td></td>
                    <td td className="negrita" align="center">
                      Total
                    </td>
                    <td td className="negrita">
                      {total_cantidad_anterior}
                    </td>
                    <td td className="negrita">
                      {total_cantidad_nueva}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
              <Row>
                <Col>
                  {validaBoton && selectedArticulo != "" ? (
                    <Button
                      type="submit"
                      size="sm"
                      className="btn"
                      color="info"
                      tabindex="-1"
                      onClick={saveUbicacion}
                      id="logoutBoton"
                    >
                      Guardar
                    </Button>
                  ) : undefined}
                </Col>
              </Row>
            </>
          ) : (
            <h4>No se encontraron Movimientos....</h4>
          )}
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoUbicaciones;
